import { Pill } from "@jelly/ui";
import React, { useState } from "react";

import styles from "./Page01.module.scss";
import Slider from "@src/lms/jelly/extensions/components/slider/Slider";
import { Fig11, Fig12, Fig13 } from "@src/lms/jelly/extensions/layouts/_lesson/lesson05/images";
// import classNames from "classnames";

export interface Lesson0105Page01Props {
  xLabel: string;
  yLabel: string;
  zLabel: string;
}

export const Lesson0105Page01: React.FC<Lesson0105Page01Props> = ({ xLabel, yLabel, zLabel }) => {
  const [x, setX] = useState(50);
  const [y, setY] = useState(50);
  const [z, setZ] = useState(50);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.imagesRow}>
        <Fig11 x={x / 100} y={y / 100} z={z / 100} />
        <Fig12 x={x / 100} y={y / 100} z={z / 100} />

        <Fig13
          //center bias applied on input
          x={x / 100}
          y={y / 100}
          z={z / 100}
        />
      </div>
      <div className={styles.slidersRow}>
        <div className={styles.sliderRow}>
          <Pill theme="default" size="small">
            {xLabel}
          </Pill>
          <Slider theme="primary" value={x} min={0} max={100} onChange={(val) => setX(val)} />
        </div>
        <div className={styles.sliderRow}>
          <Pill theme="default" size="small">
            {yLabel}
          </Pill>
          <Slider theme="primary" value={y} min={0} max={100} onChange={(val) => setY(val)} />
        </div>
        <div className={styles.sliderRow}>
          <Pill theme="default" size="small">
            {zLabel}
          </Pill>
          <Slider theme="primary" value={z} min={0} max={100} onChange={(val) => setZ(val)} />
        </div>
      </div>
    </div>
  );
};
